var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7062",
    "data-name": "Rectangle 7062",
    width: 48,
    height: 48,
    transform: "translate(726 405)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cashless",
    transform: "translate(-726 -405)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28038",
    "data-name": "Group 28038",
    transform: "translate(583.578 90.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28038-2",
    "data-name": "Group 28038",
    transform: "translate(151.333 322.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31146",
    "data-name": "Path 31146",
    d: "M173.1,329v.86h5.887v-4.25H154.66v4.25h4.992V329Z",
    transform: "translate(-151.736 -322.689)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31147",
    "data-name": "Path 31147",
    d: "M151.333,322.286v10.1h7.916V329.46h-4.992v-4.25h24.329v4.25H172.7v2.267h3.127v.657h5.684v-10.1Z",
    transform: "translate(-151.333 -322.286)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31148",
    "data-name": "Path 31148",
    d: "M174.22,333.026v19.291H163.9v3.127h13.451V333.026Z",
    transform: "translate(-152.853 -323.586)",
    fill: "#002c77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28039",
    "data-name": "Group 28039",
    transform: "translate(157.386 326.874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7064",
    "data-name": "Rectangle 7064",
    width: 13.45,
    height: 22.417,
    fill: "#ffb063"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashless);
export default __webpack_public_path__ + "static/media/cashless.60f7963beff3d61eaab63327718ef033.svg";
export { ForwardRef as ReactComponent };